import React from 'react';
import { PlayCircleIcon, PauseCircleIcon } from '@metarouter-private/mr-mui';

import { useUpdatePipelineIntegration, notify } from '@ion/api';

import { usePipelineIntegrationModalContext } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/context/pipeline-integration-modal-context';

import INTEGRATION_ACTIVATION_MODAL_NAME from './INTEGRATION_ACTIVATION_MODAL_NAME';
import IntegrationActivationModalContent from './IntegrationActivationModalContent';
import CONFIRM_MODAL_EMPTY_STATE from './CONFIRM_MODAL_EMPTY_STATE';

const MODAL_TYPE_CONFIGS = {
  ENABLING_INTEGRATION: {
    title: 'Stage Integration for Activation',
    titleIcon: PlayCircleIcon,
    confirmLabel: 'Stage Activation',
  },
  DISABLING_INTEGRATION: {
    title: 'Stage Integration for Pause',
    titleIcon: PauseCircleIcon,
    confirmLabel: 'Stage Pause',
  },
};

const CANCEL_LABEL = 'Cancel';

export default function useIntegrationActivationModalProps() {
  const { isOpenModal, modalContentOption, selectedIntegration, onCloseModal } = usePipelineIntegrationModalContext();
  const [updatePipelineIntegration] = useUpdatePipelineIntegration({
    onCompleted: onCloseModal,
    onError: () => {
      notify.error({ message: 'Integration status update failed' });
    },
  });

  const activationModalSelected = modalContentOption === INTEGRATION_ACTIVATION_MODAL_NAME;

  // Prevent the modal props from being evaluated if `selectedIntegration` is not available
  if (!activationModalSelected) {
    return CONFIRM_MODAL_EMPTY_STATE;
  }

  const isOpen = Boolean(isOpenModal && activationModalSelected);

  const modalConfig = selectedIntegration.pipelineIntegration.disabled
    ? MODAL_TYPE_CONFIGS.ENABLING_INTEGRATION
    : MODAL_TYPE_CONFIGS.DISABLING_INTEGRATION;

  const title = modalConfig.title;
  const TitleIcon = modalConfig.titleIcon;
  const message = (
    <IntegrationActivationModalContent
      integrationName={selectedIntegration.integration.name}
      shouldDisable={!selectedIntegration.pipelineIntegration.disabled}
    />
  );
  const ConfirmProps = {
    color: selectedIntegration.pipelineIntegration.disabled ? 'primary' : 'warning',
    'data-test-id': 'confirmIntegrationActivationChange',
  };

  const onConfirm = () => {
    updatePipelineIntegration({
      pipelineIntegration: selectedIntegration.pipelineIntegration,
      playbookId: selectedIntegration.playbookId,
      disabled: !selectedIntegration.pipelineIntegration.disabled, // Flip disabled state
      pipelineVars: selectedIntegration.pipelineVars,
      readyForDeploy: selectedIntegration.readyForDeploy,
    });
  };

  return {
    open: isOpen,
    onConfirm,
    title,
    TitleIcon,
    message,
    cancelLabel: CANCEL_LABEL,
    confirmLabel: modalConfig.confirmLabel,
    ConfirmProps,
    onClose: onCloseModal,
  };
}
